// ======================================================================
// File: IndentListPage.jsx
// Module: PPE → Procurement → Indent
// ======================================================================

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import useIndentList from "../hooks/useIndentList";

import IndentFilterBar from "./IndentFilterBar";
import indentColumns from "./indentColumns";
import IndentKpiBar from "./IndentKpiBar";

import IndentFormDrawer from "../form/IndentFormDrawer";

export default function IndentListPage() {
  const navigate = useNavigate();

  // --------------------------------------------------
  // LIST DATA
  // --------------------------------------------------
  const {
    items,
    allRows,
    total,
    loading,
    page,
    pageSize,
    setPage,
    filters,
    setFilters,
    reload,
  } = useIndentList();

  // --------------------------------------------------
  // DRAWER STATE  ✅ SAME AS PROCESS MASTER
  // --------------------------------------------------
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState("create"); // create | edit
  const [selectedIndent, setSelectedIndent] =
    useState(null);

  const canCreate = true;
  const canEdit = true;

  // --------------------------------------------------
  // DRAWER HANDLERS
  // --------------------------------------------------
  const openCreateDrawer = () => {
    setSelectedIndent(null);
    setDrawerMode("create");
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedIndent(null);
  };

  // --------------------------------------------------
  // UI
  // --------------------------------------------------
  return (
    <div>
      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}
      <div
        style={{
          background:
            "linear-gradient(90deg, #0f766e 0%, #14b8a6 50%, #5eead4 100%)",
          borderRadius: 12,
          padding: "16px 20px",
          color: "#fff",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h4 style={{ margin: 0 }}>
            Indent Management
          </h4>
          <div style={{ fontSize: 13, opacity: 0.9 }}>
            Internal material demand authorization
          </div>
        </div>

        {canCreate && (
          <button
            className="btn btn-light"
            onClick={openCreateDrawer}
          >
            + Create Indent
          </button>
        )}
      </div>

      {/* ====================================================== */}
      {/* KPI STRIP */}
      {/* ====================================================== */}
      
      <IndentKpiBar rows={allRows} />

      {/* ====================================================== */}
      {/* FILTER BAR */}
      {/* ====================================================== */}
      <IndentFilterBar
        filters={filters}
        onChange={setFilters}
        onSearch={reload}
      />

      {/* ====================================================== */}
      {/* TABLE */}
      {/* ====================================================== */}
      <div className="card">
        <div className="card-body p-0">
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                {indentColumns.map((c) => (
                  <th key={c.key}>{c.title}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
                  <td
                    colSpan={10}
                    className="text-center"
                  >
                    Loading...
                  </td>
                </tr>
              )}

              {!loading && items.length === 0 && (
                <tr>
                  <td
                    colSpan={10}
                    className="text-center text-muted"
                  >
                    No records found
                  </td>
                </tr>
              )}

              {!loading &&
                items.map((row) => (
                  <tr key={row.id}>
                    {indentColumns.map((col) => (
                      <td key={col.key}>
                        {col.render
                          ? col.render(row, {
                              navigate,
                              canEdit,
                            })
                          : row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ====================================================== */}
      {/* PAGINATION */}
      {/* ====================================================== */}
      <div className="erp-pagination">
        <span>
          Page {page} of{" "}
          {Math.ceil(total / pageSize)}
        </span>

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </button>

        <button
          disabled={page * pageSize >= total}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>

      {/* ====================================================== */}
      {/* DRAWER */}
      {/* ====================================================== */}
      <IndentFormDrawer
        open={drawerOpen}
        mode={drawerMode}
        record={selectedIndent}
        onClose={closeDrawer}
        onSaved={reload}
      />
    </div>
  );
}
